// import React, { useState, useEffect } from 'react';

// const StockMangement = () => {
//   const [products, setProducts] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [editingProduct, setEditingProduct] = useState(null);

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   const fetchProducts = async () => {
//     try {
//       const response = await fetch('/api/products');
//       if (!response.ok) throw new Error('Failed to fetch products');
//       const data = await response.json();
//       setProducts(data);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm('Are you sure you want to delete this product?')) {
//       try {
//         const response = await fetch(`/api/products/${id}`, {
//           method: 'DELETE',
//         });
//         if (!response.ok) throw new Error('Failed to delete product');
//         setProducts(products.filter(product => product._id !== id));
//       } catch (err) {
//         setError(err.message);
//       }
//     }
//   };

//   const handleEdit = (product) => {
//     setEditingProduct({ ...product });
//     setEditModalOpen(true);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditingProduct(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSizeChange = (index, field, value) => {
//     const newSizes = [...editingProduct.sizes];
//     newSizes[index] = {
//       ...newSizes[index],
//       [field]: field === 'price' || field === 'quantity' || field === 'offerPercentage' 
//         ? Number(value) 
//         : value
//     };

//     if (field === 'price' || field === 'offerPercentage') {
//       const price = newSizes[index].price;
//       const offerPercentage = newSizes[index].offerPercentage;
//       newSizes[index].sellingPrice = price - (price * (offerPercentage / 100));
//     }

//     setEditingProduct(prev => ({
//       ...prev,
//       sizes: newSizes
//     }));
//   };

//   const addSize = () => {
//     setEditingProduct(prev => ({
//       ...prev,
//       sizes: [...prev.sizes, {
//         size: '',
//         quantity: 0,
//         price: 0,
//         offerPercentage: 0,
//         sellingPrice: 0,
//         sizeId: Date.now().toString()
//       }]
//     }));
//   };

//   const removeSize = (index) => {
//     setEditingProduct(prev => ({
//       ...prev,
//       sizes: prev.sizes.filter((_, i) => i !== index)
//     }));
//   };

//   const handleSubmit = async () => {
//     try {
//       const response = await fetch(`/api/products/${editingProduct._id}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(editingProduct),
//       });

//       if (!response.ok) throw new Error('Failed to update product');

//       const updatedProduct = await response.json();
//       setProducts(products.map(p => 
//         p._id === updatedProduct._id ? updatedProduct : p
//       ));

//       setEditModalOpen(false);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   if (loading) return <div className="text-center p-4">Loading...</div>;
//   if (error) return <div className="text-red-500 p-4">{error}</div>;

//   return (
//     <div className="container mx-auto p-4">
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl font-bold">Products</h1>
//         <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
//           Add Product
//         </button>
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
//         {products.map((product) => (
//           <div key={product._id} className="border rounded-lg shadow-sm bg-white">
//             <div className="p-4">
//               {product.images && product.images[0] && (
//                 <img
//                   src={product.images[0]}
//                   alt={product.productName}
//                   className="w-full h-48 object-cover mb-4 rounded"
//                 />
//               )}
//               <h3 className="font-semibold text-lg mb-2">{product.productName}</h3>
//               <p className="text-gray-600 mb-2">{product.caption}</p>
//               <div className="flex flex-wrap gap-2 mb-2">
//                 {product.sizes.map((size, index) => (
//                   <span key={index} className="text-sm bg-gray-100 rounded-full px-3 py-1">
//                     {size.size}: ${size.sellingPrice}
//                   </span>
//                 ))}
//               </div>
//               <div className="flex justify-end gap-2 mt-auto">
//                 <button 
//                   className="px-3 py-1 border rounded hover:bg-gray-100"
//                   onClick={() => handleEdit(product)}
//                 >
//                   Edit
//                 </button>
//                 <button 
//                   className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
//                   onClick={() => handleDelete(product._id)}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {editModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-bold">Edit Product</h2>
//               <button 
//                 onClick={() => setEditModalOpen(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 ✕
//               </button>
//             </div>

//             <div className="space-y-4">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Product Name</label>
//                   <input
//                     className="w-full px-3 py-2 border rounded"
//                     name="productName"
//                     value={editingProduct?.productName || ''}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Product Code</label>
//                   <input
//                     className="w-full px-3 py-2 border rounded"
//                     name="productCode"
//                     value={editingProduct?.productCode || ''}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Category Code</label>
//                   <input
//                     className="w-full px-3 py-2 border rounded"
//                     name="categoryCode"
//                     value={editingProduct?.categoryCode || ''}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Category Name</label>
//                   <input
//                     className="w-full px-3 py-2 border rounded"
//                     name="categoryName"
//                     value={editingProduct?.categoryName || ''}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Aroma</label>
//                   <input
//                     className="w-full px-3 py-2 border rounded"
//                     name="Aroma"
//                     value={editingProduct?.Aroma || ''}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Category ID</label>
//                   <input
//                     className="w-full px-3 py-2 border rounded"
//                     name="categoryId"
//                     type="number"
//                     value={editingProduct?.categoryId || ''}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">Caption</label>
//                 <input
//                   className="w-full px-3 py-2 border rounded"
//                   name="caption"
//                   value={editingProduct?.caption || ''}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">Description</label>
//                 <textarea
//                   className="w-full px-3 py-2 border rounded"
//                   name="description"
//                   value={editingProduct?.description || ''}
//                   onChange={handleChange}
//                   rows={3}
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">Uses</label>
//                 <textarea
//                   className="w-full px-3 py-2 border rounded"
//                   name="uses"
//                   value={editingProduct?.uses || ''}
//                   onChange={handleChange}
//                   rows={3}
//                 />
//               </div>

//               <div>
//                 <div className="flex justify-between items-center mb-2">
//                   <label className="block text-sm font-medium">Sizes</label>
//                   <button 
//                     type="button"
//                     className="px-3 py-1 border rounded hover:bg-gray-100"
//                     onClick={addSize}
//                   >
//                     Add Size
//                   </button>
//                 </div>
//                 {editingProduct?.sizes.map((size, index) => (
//                   <div key={size.sizeId} className="grid grid-cols-5 gap-2 mb-2">
//                     <input
//                       className="px-3 py-2 border rounded"
//                       placeholder="Size"
//                       value={size.size}
//                       onChange={(e) => handleSizeChange(index, 'size', e.target.value)}
//                     />
//                     <input
//                       className="px-3 py-2 border rounded"
//                       type="number"
//                       placeholder="Quantity"
//                       value={size.quantity}
//                       onChange={(e) => handleSizeChange(index, 'quantity', e.target.value)}
//                     />
//                     <input
//                       className="px-3 py-2 border rounded"
//                       type="number"
//                       placeholder="Price"
//                       value={size.price}
//                       onChange={(e) => handleSizeChange(index, 'price', e.target.value)}
//                     />
//                     <input
//                       className="px-3 py-2 border rounded"
//                       type="number"
//                       placeholder="Offer %"
//                       value={size.offerPercentage}
//                       onChange={(e) => handleSizeChange(index, 'offerPercentage', e.target.value)}
//                     />
//                     <button 
//                       type="button"
//                       className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
//                       onClick={() => removeSize(index)}
//                     >
//                       ✕
//                     </button>
//                   </div>
//                 ))}
//               </div>

//               <div className="flex justify-end gap-2 mt-4">
//                 <button 
//                   className="px-4 py-2 border rounded hover:bg-gray-100"
//                   onClick={() => setEditModalOpen(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button 
//                   className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//                   onClick={handleSubmit}
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default StockMangement;

// import React, { useState, useEffect } from 'react';
// import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin'
// import { RiDeleteBin6Line } from "react-icons/ri";
// import { MdOutlineEdit } from "react-icons/md";
// import "./Stockmangement.css"

// const StockManagement = () => {
//   const [products, setProducts] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [editingProduct, setEditingProduct] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [categories, setCategories] = useState([]);

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   const fetchProducts = async () => {
//     try {
//       const response = await fetch('/api/products');
//       if (!response.ok) throw new Error('Failed to fetch products');
//       const data = await response.json();
//       setProducts(data);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm('Are you sure you want to delete this product?')) {
//       try {
//         const response = await fetch(`/api/products/${id}`, {
//           method: 'DELETE',
//         });
//         if (!response.ok) throw new Error('Failed to delete product');
//         setProducts(products.filter(product => product._id !== id));
//       } catch (err) {
//         setError(err.message);
//       }
//     }
//   };

//   const handleEdit = (product) => {
//     setEditingProduct({ ...product });
//     setEditModalOpen(true);
//   };

//   const closeModal = () => {
//     setEditModalOpen(false);
//     setEditingProduct(null);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditingProduct(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSizeChange = (index, field, value) => {
//     const newSizes = [...editingProduct.sizes];
//     newSizes[index] = {
//       ...newSizes[index],
//       [field]: field === 'price' || field === 'quantity' || field === 'offerPercentage'
//         ? Number(value)
//         : value
//     };

//     if (field === 'price' || field === 'offerPercentage') {
//       const price = newSizes[index].price;
//       const offerPercentage = newSizes[index].offerPercentage;
//       newSizes[index].sellingPrice = price - (price * (offerPercentage / 100));
//     }

//     setEditingProduct(prev => ({
//       ...prev,
//       sizes: newSizes
//     }));
//   };

//   const addSize = () => {
//     setEditingProduct(prev => ({
//       ...prev,
//       sizes: [...prev.sizes, {
//         size: '',
//         quantity: 0,
//         price: 0,
//         offerPercentage: 0,
//         sellingPrice: 0,
//         sizeId: Date.now().toString()
//       }]
//     }));
//   };

//   const removeSize = (index) => {
//     setEditingProduct(prev => ({
//       ...prev,
//       sizes: prev.sizes.filter((_, i) => i !== index)
//     }));
//   };

//   const handleSubmit = async () => {
//     try {
//       const response = await fetch(`/api/products/${editingProduct._id}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(editingProduct),
//       });

//       if (!response.ok) throw new Error('Failed to update product');

//       const updatedProduct = await response.json();
//       setProducts(products.map(p =>
//         p._id === updatedProduct._id ? updatedProduct : p
//       ));

//       closeModal();
//     } catch (err) {
//       setError(err.message);
//     }
//   };
//   const filteredProducts = products.filter(product => {
//     const matchesSearch = product.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       product.caption.toLowerCase().includes(searchTerm.toLowerCase());
//     const matchesCategory = selectedCategory === '' || product.categoryName === selectedCategory;
//     return matchesSearch && matchesCategory;
//   });

//   // Pagination calculations
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleCategoryChange = (e) => {
//     setSelectedCategory(e.target.value);
//     setCurrentPage(1);
//   };

//   if (loading) return <div className="text-center p-4">Loading...</div>;
//   if (error) return <div className="text-red-500 p-4">{error}</div>;

//   return (
//     <>
//       <div className="breadcrumb-wrap bg-f br-1">
//         {/* <div className="container">
//           <div className="breadcrumb-title">
//             <h2>Admin</h2>
//             <ul className="breadcrumb-menu list-style">
//               <li><a href="index.html">Home </a></li>
//               <li>Admin</li>
//             </ul>
//           </div>
//         </div> */}
//       </div>

//         <div className="containerorder">
//         <div className="row ">
//           <div class="col-xl-2 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
//             <LeftSideNavaBarAdmin /></div>
//             <div className="col-xl-10 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">


//               <div className="filters-container">
//                 <div className="search-box">
//                   <input
//                     type="text"
//                     placeholder="Search products..."
//                     value={searchTerm}
//                     onChange={handleSearch}
//                   />
//                 </div>

//                 <div className="filter-select1">
//                   <select
//                     value={selectedCategory}
//                     onChange={handleCategoryChange}
//                   >
//                     <option value="">All Categories</option>
//                     {categories.map((category, index) => (
//                       <option key={index} value={category}>
//                         {category}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="filter-select1 items-per-page">
//                   <select
//                     value={itemsPerPage}
//                     onChange={handleItemsPerPageChange}
//                   >
//                     <option value={5}>5 per page</option>
//                     <option value={10}>10 per page</option>
//                     <option value={20}>20 per page</option>
//                     <option value={50}>50 per page</option>
//                   </select>
//                 </div>
//               </div>

//               {/* Products Table */}
//               <div className="table-container ">
//                 <div className="overflow-x-auto">
//                   <table className="w-full">
//                     <thead className="bg-gray-50">
//                       <tr>
//                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
//                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
//                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
//                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sizes & Prices</th>
//                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody className="bg-white divide-y divide-gray-200">
//                       {currentItems.map((product) => (
//                         <tr key={product._id} >
//                           <td >
//                             <div >
//                               {product.images && product.images[0] && (
//                                 <img
//                                   src={product.images[0]}
//                                   // src='/assets/img/products/AJIT2352 a.jpg'
//                                   alt={product.productName}
//                                   className="stockimg "
//                                 />
//                               )}
//                             </div>
//                           </td>
//                           <td className="px-6 py-4" >
//                             <div className="text-sm font-medium text-gray-900">{product.productName}</div>
//                             <div className="text-sm text-gray-500">{product.caption}</div>
//                           </td>
//                           <td className="px-6 py-4 whitespace-nowrap">
//                             <div className="text-sm text-gray-900">{product.categoryName}</div>
//                           </td>
//                           <td className="px-6 py-4">
//                             <div className="flex flex-wrap gap-2">
//                               {product.sizes.map((size, index) => (
//                                 <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                                   {size.size}: ₹{size.sellingPrice}
//                                 </span>
//                               ))}
//                             </div>
//                           </td>
//                           <td className="px-6 py-4 whitespace-nowrap">
//                             <div className="flex space-x-2">
//                               <button
//                                 onClick={() => handleEdit(product)}
//                                 className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200"
//                               >
//                                 <MdOutlineEdit className="w-5 h-5" />
//                               </button>
//                               <button
//                                 onClick={() => handleDelete(product._id)}
//                                 className="p-2 bg-red-100 text-red-600 rounded-full hover:bg-red-200"
//                               >
//                                 <RiDeleteBin6Line className="w-5 h-5" />
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               {/* Pagination */}
//               <div className="flex items-center justify-between bg-white px-4 py-3 mt-4 rounded-lg shadow">
//                 <div className="flex justify-between items-center w-full">
//                   <div className="text-sm text-gray-700">
//                     Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredProducts.length)} of {filteredProducts.length} items
//                   </div>
//                   <div className="flex gap-2">
//                     <button
//                       onClick={() => paginate(currentPage - 1)}
//                       disabled={currentPage === 1}
//                       className="px-3 py-1 border rounded-md disabled:opacity-50"
//                     >
//                       Previous
//                     </button>
//                     {[...Array(totalPages)].map((_, index) => (
//                       <button
//                         key={index + 1}
//                         onClick={() => paginate(index + 1)}
//                         className={`px-3 py-1 border rounded-md ${currentPage === index + 1 ? 'bg-blue-500 text-white' : ''
//                           }`}
//                       >
//                         {index + 1}
//                       </button>
//                     ))}
//                     <button
//                       onClick={() => paginate(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                       className="px-3 py-1 border rounded-md disabled:opacity-50"
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>


//             {editModalOpen && (
//               <div className="absolute inset-0 flex items-center justify-center stockeditmodel">
//                 <div
//                   className="absolute inset-0 bg-black bg-opacity-50"
//                   onClick={closeModal}
//                 />
//                 <div
//                   className="relative bg-white rounded-lg shadow-xl w-full max-w-2xl m-4 max-h-[90vh] overflow-y-auto z-10"
//                   onClick={e => e.stopPropagation()}
//                 >
//                   <div className="p-6">
//                     <div className="flex justify-between items-center mb-4">
//                       <h2 className="text-xl font-bold">Edit Product</h2>
//                       <button
//                         onClick={closeModal}
//                         className="stockeditclose"
//                       >
//                         ✕
//                       </button>
//                     </div>

//                     <div className="space-y-4 modelinner">

//                       <div className='d-flex gap-2'>
//                         <div className='input-container'>
//                           <input
//                             type='text'
//                             id='productName'
//                             name="productName"
//                             value={editingProduct?.productName || ''}
//                             onChange={handleChange}
//                             required
//                           />
//                           <label className="label">Product Name</label>
//                         </div>

//                         <div className='input-container'>

//                           <input
//                             type='text'
//                             name="productCode"
//                             value={editingProduct?.productCode || ''}
//                             onChange={handleChange}
//                             required
//                           />
//                           <label className="label">Product Code</label>
//                         </div>
//                       </div>
//                       <div className='d-flex gap-2'>
//                         <div className='input-container'>

//                           <input
//                             type='text'
//                             name="categoryCode"
//                             value={editingProduct?.categoryCode || ''}
//                             onChange={handleChange}
//                             required
//                           />
//                           <label className="label">Category Code</label>
//                         </div>
//                         <div className='input-container'>

//                           <input
//                             type='text'
//                             name="categoryName"
//                             value={editingProduct?.categoryName || ''}
//                             onChange={handleChange}
//                             required
//                           />
//                           <label className="label">Category Name</label>
//                         </div>
//                       </div>
//                       <div className='d-flex gap-2'>
//                         <div className='input-container'>

//                           <input
//                             type='text'
//                             name="Aroma"
//                             value={editingProduct?.Aroma || ''}
//                             onChange={handleChange}
//                             required
//                           />
//                           <label className="label">Aroma</label>
//                         </div>
//                         <div className='input-container'>

//                           <input
//                             name="categoryId"
//                             type="number"
//                             value={editingProduct?.categoryId || ''}
//                             onChange={handleChange}
//                             required
//                           />
//                           <label className="label">Category ID</label>
//                         </div>
//                       </div>


//                       <div className='input-container'>
//                         <input
//                           type='text'
//                           name="caption"
//                           value={editingProduct?.caption || ''}
//                           onChange={handleChange}
//                         />
//                         <label className="label">Caption</label>
//                       </div>

//                       <div className='input-container'>
//                         <textarea
//                           className="rounded"
//                           name="description"
//                           value={editingProduct?.description || ''}
//                           onChange={handleChange}
//                           rows={3}
//                         />
//                         <label className="label">Description</label>
//                       </div>

//                       <div className='input-container'>

//                         <textarea
//                           className="rounded"
//                           name="uses"
//                           value={editingProduct?.uses || ''}
//                           onChange={handleChange}
//                           rows={3}
//                         />
//                         <label className="label">Uses</label>
//                       </div>

//                       <div className='formitem'>

//                         <button
//                           type="button"
//                           className=""
//                           onClick={addSize}
//                         >
//                           Add New Size
//                         </button>
//                         <label></label>
//                         {editingProduct?.sizes.map((size, index) => (
//                           <div key={size.sizeId} className="grid grid-cols-5 gap-2 mb-2">
//                             <input
//                               className="px-3 py-2 border rounded"
//                               placeholder="Size"
//                               value={size.size}
//                               onChange={(e) => handleSizeChange(index, 'size', e.target.value)}
//                             />
//                             <input
//                               className="px-3 py-2 border rounded"
//                               type="number"
//                               placeholder="Quantity"
//                               value={size.quantity}
//                               onChange={(e) => handleSizeChange(index, 'quantity', e.target.value)}
//                             />
//                             <input
//                               className="px-3 py-2 border rounded"
//                               type="number"
//                               placeholder="Price"
//                               value={size.price}
//                               onChange={(e) => handleSizeChange(index, 'price', e.target.value)}
//                             />
//                             <input
//                               className="px-3 py-2 border rounded"
//                               type="number"
//                               placeholder="Offer %"
//                               value={size.offerPercentage}
//                               onChange={(e) => handleSizeChange(index, 'offerPercentage', e.target.value)}
//                             />
//                             <button
//                               type="button"
//                               className=""
//                               onClick={() => removeSize(index)}
//                             >
//                               ✕
//                             </button>
//                           </div>
//                         ))}
//                       </div>

//                       <div className="flex justify-end gap-2 mt-4 formitem">
//                         <button
//                           className="px-4 py-2 border rounded hover:bg-gray-100"
//                           onClick={closeModal}
//                         >
//                           Cancel
//                         </button>
//                         <button
//                           className="px-4 py-2 rounded hover:bg-blue-600"
//                           onClick={handleSubmit}
//                         >
//                           Save Changes
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//     </>
//   );
// };

// export default StockManagement;





// import React, { useState, useEffect } from 'react';
// import { Edit, Search } from 'lucide-react';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableContainer,
//   Paper,
//   TextField,
//   Button,
//   Typography,
//   Box,
//   CircularProgress,
//   InputAdornment,
//   TablePagination,
//   Container,
//   Chip,
//   IconButton,
//   useTheme
// } from '@mui/material';
// import ProductEditModal from './ProductEditModal';
// import LeftSideNavBarAdmin from './LeftSideNavaBarAdmin';

// const StockManagement = () => {
//   const theme = useTheme();
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   const fetchProducts = async () => {
//     try {
//       const response = await fetch('/api/products');
//       const data = await response.json();
//       setProducts(data);
//     } catch (error) {
//       console.error('Error fetching products:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (product) => {
//     setSelectedProduct(product);
//     setOpen(true);
//   };

//   const handleSave = async (updatedProduct) => {
//     try {
//       const response = await fetch(`/api/products/${updatedProduct._id}`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(updatedProduct)
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setProducts(products.map(p => p._id === data._id ? data : p));
//         setOpen(false);
//         setSelectedProduct(null);
//       }
//     } catch (error) {
//       console.error('Error updating product:', error);
//     }
//   };

//   // Enhanced search functionality to search through all product details
//   const filteredProducts = products.filter(product => {
//     const searchFields = [
//       product.productName,
//       product.productCode,
//       product.categoryName,
//       ...(product.aromas?.flatMap(aroma => [
//         aroma.name,
//         ...aroma.sizes.flatMap(size => [
//           size.size.toString(),
//           size.unit,
//           size.sellingPrice.toString(),
//           size.offer.toString()
//         ])
//       ]) || [])
//     ];

//     return searchFields.some(field =>
//       field?.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   });

//   const renderAromaInfo = (aromas) => {
//     return aromas?.map((aroma, index) => (
//       <Box key={index} sx={{ mb: 1 }}>
//         <Typography variant="subtitle2" color="primary">
//           {aroma.name}
//         </Typography>
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
//           {aroma.sizes.map((size, sizeIndex) => (
//             <Chip
//               key={sizeIndex}
//               size="small"
//               label={`${size.size}${size.unit} - ₹${size.sellingPrice}${size.offer > 0 ? ` (${size.offer}% off)` : ''}`}
//               sx={{
//                 backgroundColor: theme.palette.primary.light,
//                 color: theme.palette.primary.contrastText,
//               }}
//             />
//           ))}
//         </Box>
//       </Box>
//     ));
//   };

//   if (loading) {
//     return (
//       <Box display="flex" alignItems="center" justifyContent="center" height="64vh">
//         <CircularProgress />
//         <Typography sx={{ ml: 2 }}>Loading products...</Typography>
//       </Box>
//     );
//   }

//   return (
//     <>
//       <div class="breadcrumb-wrap bg-f br-1">
//         <div class="container">
//           <div class="breadcrumb-title">

//           </div>
//         </div>
//       </div>
//       <div className="containerorder">
//         <div className="row ">
//           <div class="col-xl-3 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
//             <LeftSideNavBarAdmin /></div>
//           <div className="col-xl-9 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
//             <Box sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               mb: 3,
//               flexDirection: { xs: 'column', sm: 'row' },
//               gap: 2
//             }}>
//               <Typography
//                 variant="h4"
//                 component="h1"
//                 color="primary"
//                 sx={{ fontWeight: 'bold' }}
//               >
//                 Product Management
//               </Typography>

//               <TextField
//                 placeholder="Search in all product details..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Search color={theme.palette.primary.main} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   width: { xs: '100%', sm: '300px' },
//                   '& .MuiOutlinedInput-root': {
//                     borderRadius: 2,
//                     '&:hover fieldset': {
//                       borderColor: theme.palette.primary.main,
//                     },
//                   },
//                 }}
//                 size="small"
//               />
//             </Box>

//             {/* Product Table */}
//             <TableContainer
//               component={Paper}
//               sx={{
//                 mb: 3,
//                 boxShadow: 3,
//                 borderRadius: 2,
//                 overflow: 'hidden'
//               }}
//             >
//               <Table>
//                 <TableHead>
//                   <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
//                     <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Product Name</TableCell>
//                     <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Category</TableCell>
//                     <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Product Code</TableCell>
//                     <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Aromas & Sizes</TableCell>
//                     <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {filteredProducts
//                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                     .map((product) => (
//                       <TableRow
//                         key={product._id}
//                         sx={{ '&:hover': { bgcolor: theme.palette.action.hover } }}
//                       >
//                         <TableCell>
//                           <Typography variant="subtitle2" color="primary.dark">
//                             {product.productName}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Chip
//                             label={product.categoryName}
//                             size="small"
//                           // sx={{ bgcolor: theme.palette.secondary.light }}
//                           />
//                         </TableCell>
//                         <TableCell>{product.productCode}</TableCell>
//                         <TableCell>{renderAromaInfo(product.aromas)}</TableCell>
//                         <TableCell>
//                           <IconButton
//                             onClick={() => handleEdit(product)}
//                             color="primary"
//                             size="small"
//                           >
//                             <Edit />
//                           </IconButton>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             {/* Pagination */}
//             <TablePagination
//               component="div"
//               count={filteredProducts.length}
//               page={page}
//               rowsPerPage={rowsPerPage}
//               onPageChange={(event, newPage) => setPage(newPage)}
//               onRowsPerPageChange={(event) => {
//                 setRowsPerPage(parseInt(event.target.value, 10));
//                 setPage(0);
//               }}
//               rowsPerPageOptions={[5, 10, 25]}
//               sx={{
//                 '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
//                   m: 0,
//                 },
//               }}
//             />

//             {/* Edit Product Modal */}
//             <ProductEditModal
//               open={open}
//               onClose={() => {
//                 setOpen(false);
//                 setSelectedProduct(null);
//               }}
//               product={selectedProduct}
//               onSave={handleSave}
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default StockManagement;





import React, { useState, useEffect } from 'react';
import { Edit, Search, Trash2 } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  CircularProgress,
  InputAdornment,
  TablePagination,
  Container,
  Chip,
  IconButton,
  useTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import ProductEditModal from './ProductEditModal';
import LeftSideNavBarAdmin from './LeftSideNavaBarAdmin';


const StockManagement = () => {
  const theme = useTheme();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch('/api/products');
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };
// Handle delete confirmation dialog
const handleDeleteClick = (product) => {
  setProductToDelete(product);
  setDeleteDialogOpen(true);
};

// Handle delete confirmation
const handleDeleteConfirm = async () => {
  if (!productToDelete) return;
  
  try {
    const response = await fetch(`/api/products/${productToDelete._id}`, {
      method: 'DELETE'
    });
    
    if (response.ok) {
      // Remove the deleted product from the state
      setProducts(products.filter(p => p._id !== productToDelete._id));
      // Close the dialog
      setDeleteDialogOpen(false);
      setProductToDelete(null);
    }
  } catch (error) {
    console.error('Error deleting product:', error);
  }
};
  const handleEdit = (product) => {
    setSelectedProduct(product);
    setOpen(true);
  };

  const handleSave = async (updatedProduct) => {
    try {
      const response = await fetch(`/api/products/${updatedProduct._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedProduct)
      });
      
      if (response.ok) {
        const data = await response.json();
        setProducts(products.map(p => p._id === data._id ? data : p));
        setOpen(false);
        setSelectedProduct(null);
      }
    } catch (error) {
      console.error('Error updating product:', error);
    }
  };

  // Enhanced search functionality to search through all product details
  const filteredProducts = products.filter(product => {
    const searchFields = [
      product.productName,
      product.productCode,
      product.categoryName,
      ...(product.aromas?.flatMap(aroma => [
        aroma.name,
        ...aroma.sizes.flatMap(size => [
          size.size.toString(),
          size.unit,
          size.sellingPrice.toString(),
          size.offer.toString()
        ])
      ]) || [])
    ];
    
    return searchFields.some(field => 
      field?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const renderAromaInfo = (aromas) => {
    return aromas?.map((aroma, index) => (
      <Box key={index} sx={{ mb: 1 }}>
        <Typography variant="subtitle2" color="primary">
          {aroma.name}
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }} className='heading_mrp_new'>
          {aroma.sizes.map((size, sizeIndex) => (
            <Chip
              key={sizeIndex}
              size="small"
              label={`${size.size}${size.unit} - ₹${size.sellingPrice}${size.offer > 0 ? ` (${size.offer}% off)` : ''}`}
              sx={{
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.contrastText,
              }}
            />
          ))}
        </Box>
      </Box>
    ));
  };

  if (loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="64vh">
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading products...</Typography>
      </Box>
    );
  }

  return (
    <>
       <div className="breadcrumb-wrap bg-f br-1">
                <div className="container">
                    <div className="breadcrumb-title">

                    </div>
                </div>
            </div>

            <div class="containerorder">
    <div className="row">
          <div class="col-xl-3 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
            <LeftSideNavBarAdmin/>
            </div>
            <div class="col-xl-9 col-lg-12 order-xl-2 order-lg-2 order-md-2 order-2">
      {/* Header Section */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        mb: 3,
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2
      }}>
        <Typography 
          variant="h4" 
          component="h1"
          color="primary"
          sx={{ fontWeight: 'bold' }}
        >
          Product Management
        </Typography>
        
        <TextField
          placeholder="Search in all product details..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search color={theme.palette.primary.main} />
              </InputAdornment>
            ),
          }}
          sx={{
            width: { xs: '100%', sm: '300px' },
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              '&:hover fieldset': {
                borderColor: theme.palette.primary.main,
              },
            },
          }}
          size="small"
        />
      </Box>

      {/* Product Table */}
      <TableContainer 
        component={Paper} 
        sx={{ 
          mb: 3,
          boxShadow: 3,
          borderRadius: 2,
          overflow: 'hidden'
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Product Name</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Category</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Product Code</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Aromas & Sizes</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredProducts
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((product) => (
                <TableRow 
                  key={product._id}
                  sx={{ '&:hover': { bgcolor: theme.palette.action.hover } }}
                >
                  <TableCell>
                    <Typography variant="subtitle2" color="primary.dark">
                      {product.productName}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={product.categoryName}
                      size="small"
                      // sx={{ bgcolor: theme.palette.secondary.light }}
                    />
                  </TableCell>
                  <TableCell>{product.productCode}</TableCell>
                  <TableCell className='heading_mrp_new'>{renderAromaInfo(product.aromas)}</TableCell>
                  {/* <TableCell>
                    <IconButton 
                      onClick={() => handleEdit(product)}
                      color="primary"
                      size="small"
                    >
                      <Edit />
                    </IconButton>
                  </TableCell> */}
                  <TableCell>
  <IconButton 
    onClick={() => handleEdit(product)}
    color="primary"
    size="small"
  >
    <Edit />
  </IconButton>
  <IconButton 
    onClick={() => handleDeleteClick(product)}
    color="error"
    size="small"
  >
    <Trash2 />
  </IconButton>
</TableCell>
{/* Delete Confirmation Dialog */}
<Dialog
  open={deleteDialogOpen}
  onClose={() => setDeleteDialogOpen(false)}
>
  <DialogTitle>Confirm Delete</DialogTitle>
  <DialogContent>
    <DialogContentText>
      Are you sure you want to delete {productToDelete?.productName}? This action cannot be undone.
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
    <Button onClick={handleDeleteConfirm} color="error" autoFocus>
      Delete
    </Button>
  </DialogActions>
</Dialog>
                </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={filteredProducts.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[5, 10, 25]}
        sx={{
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            m: 0,
          },
        }}
      />

      {/* Edit Product Modal */}
      <ProductEditModal
        open={open}
        onClose={() => {
          setOpen(false);
          setSelectedProduct(null);
        }}
        product={selectedProduct}
        onSave={handleSave}
      />
      </div>
      </div>
      </div>
    </>
  );
};

export default StockManagement;




